export interface DropdownOption {
  prefixIcon?: string;
  text: string;
  subText?: string;
  suffixIcon?: string;
  redirectionUrl?: string;
  redirectionUrlPrfix?: string;
  identification?: string;
  howToId?: string;
  itemType?:string;
}
